export const environment = {
  name: 'production',
  url: 'https://bruiloftinjebroekzak.nl',
  apiEndpoint: 'https://bruiloftinjebroekzak.nl/api2',
  stripeApiKeyPublishable: 'pk_live_lsWK1mtoMPJbN4VJkQ2n1U02',
  googleAnalyticsKey: 'G-SFQMSMY0ZK',
  cookieYesKey: '4d0311204afb97697644d8d6'
};
